require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-finite");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

var Matrix4 = require('../core/math/Matrix4');

var Plane = require('../core/math/Plane');

var Vector3 = require('../core/math/Vector3');

var _require = require('./ops-booleans'),
    union = _require.union;

var _require2 = require('../core/CAGFactories'),
    fromPoints = _require2.fromPoints;

var _require3 = require('../core/utils'),
    isCAG = _require3.isCAG; // -- 3D transformations (OpenSCAD like notion)

/** translate an object in 2D/3D space
 * @param {Object} vector - 3D vector to translate the given object(s) by
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to translate
 * @returns {CSG} new CSG object , translated by the given amount
 *
 * @example
 * let movedSphere = translate([10,2,0], sphere())
 */


function translate(vector) {
  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    objects[_key - 1] = arguments[_key];
  }

  // v, obj or array
  // workaround needed to determine if we are dealing with an array of objects
  var _objects = objects.length >= 1 && objects[0].length ? objects[0] : objects;

  var object = _objects[0];

  if (_objects.length > 1) {
    for (var i = 1; i < _objects.length; i++) {
      // FIXME/ why is union really needed ??
      object = object.union(_objects[i]);
    }
  }

  return object.translate(vector);
}
/** scale an object in 2D/3D space
 * @param {Float|Array} scale - either an array or simple number to scale object(s) by
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to scale
 * @returns {CSG} new CSG object , scaled by the given amount
 *
 * @example
 * let scaledSphere = scale([0.2,15,1], sphere())
 */


function scale(scale) {
  for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    objects[_key2 - 1] = arguments[_key2];
  }

  // v, obj or array
  var _objects = objects.length >= 1 && objects[0].length ? objects[0] : objects;

  var object = _objects[0];

  if (_objects.length > 1) {
    for (var i = 1; i < _objects.length; i++) {
      // FIXME/ why is union really needed ??
      object = object.union(_objects[i]);
    }
  }

  return object.scale(scale);
}
/** rotate an object in 2D/3D space
 * @param {Float|Array} rotation - either an array or simple number to rotate object(s) by
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to rotate
 * @returns {CSG} new CSG object , rotated by the given amount
 *
 * @example
 * let rotatedSphere = rotate([0.2,15,1], sphere())
 */


function rotate() {
  var o;
  var i;
  var v;
  var r = 1;
  var a = arguments;

  if (!a[0].length) {
    // rotate(r,[x,y,z],o)
    r = a[0];
    v = a[1];
    i = 2;

    if (a[2].length) {
      a = a[2];
      i = 0;
    }
  } else {
    // rotate([x,y,z],o)
    v = a[0];
    i = 1;

    if (a[1].length) {
      a = a[1];
      i = 0;
    }
  }

  for (o = a[i++]; i < a.length; i++) {
    o = o.union(a[i]);
  }

  if (r !== 1) {
    return o.rotate([0, 0, 0], v, r);
  } else {
    return o.rotateX(v[0]).rotateY(v[1]).rotateZ(v[2]);
  }
}
/** apply the given matrix transform to the given objects
 * @param {Array} matrix - the 4x4 matrix to apply, as a simple 1d array of 16 elements
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to transform
 * @returns {CSG} new CSG object , transformed
 *
 * @example
 * const angle = 45
 * let transformedShape = transform([
 * cos(angle), -sin(angle), 0, 10,
 * sin(angle),  cos(angle), 0, 20,
 * 0         ,           0, 1, 30,
 * 0,           0, 0,  1
 * ], sphere())
 */


function transform(matrix) {
  for (var _len3 = arguments.length, objects = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    objects[_key3 - 1] = arguments[_key3];
  }

  // v, obj or array
  var _objects = objects.length >= 1 && objects[0].length ? objects[0] : objects;

  var object = _objects[0];

  if (_objects.length > 1) {
    for (var i = 1; i < _objects.length; i++) {
      // FIXME/ why is union really needed ??
      object = object.union(_objects[i]);
    }
  }

  var transformationMatrix;

  if (!Array.isArray(matrix)) {
    throw new Error('Matrix needs to be an array');
  }

  matrix.forEach(function (element) {
    if (!Number.isFinite(element)) {
      throw new Error('you can only use a flat array of valid, finite numbers (float and integers)');
    }
  });
  transformationMatrix = new Matrix4(matrix);
  return object.transform(transformationMatrix);
}
/**
 * Center the given object(s) about the given axes
 * @param {Array|Boolean} axes=[true,true,true]|true  - an array of boolean values that indicate the axes (X,Y,Z) to center upon. A single boolean is also allowed.
 * @param {...Object} object one or more objects to center, i.e. objects are CSG or CAG
 * @returns {CSG} new CSG object , translated by the given amount
 *
 * @example
 * let csg = center([true,false,false], sphere()) // center about the X axis
 */


function center(axes) {
  for (var _len4 = arguments.length, objects = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    objects[_key4 - 1] = arguments[_key4];
  }

  var _objects = objects.length >= 1 && objects[0].length ? objects[0] : objects;

  var object = _objects[0];

  if (_objects.length > 1) {
    for (var i = 1; i < _objects.length; i++) {
      // FIXME/ why is union really needed ??
      object = object.union(_objects[i]);
    }
  }

  if (!Array.isArray(axes)) {
    axes = [axes, axes, axes];
  }

  return object.center(axes);
}
/** mirror an object in 2D/3D space
 * @param {Array} vector - the axes to mirror the object(s) by
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to mirror
 * @returns {CSG} new CSG object , mirrored
 *
 * @example
 * let rotatedSphere = mirror([0.2,15,1], sphere())
 */


function mirror(vector) {
  for (var _len5 = arguments.length, objects = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    objects[_key5 - 1] = arguments[_key5];
  }

  var _objects = objects.length >= 1 && objects[0].length ? objects[0] : objects;

  var object = _objects[0];

  if (_objects.length > 1) {
    for (var i = 1; i < _objects.length; i++) {
      // FIXME/ why is union really needed ??
      object = object.union(_objects[i]);
    }
  }

  var plane = new Plane(new Vector3(vector[0], vector[1], vector[2]).unit(), 0);
  return object.mirrored(plane);
}
/** expand an object in 2D/3D space
 * @param {float} radius - the radius to expand by
 * @param {Object} object a CSG/CAG objects to expand
 * @returns {CSG/CAG} new CSG/CAG object , expanded
 *
 * @example
 * let expanededShape = expand([0.2,15,1], sphere())
 */


function expand(radius, n, object) {
  return object.expand(radius, n);
}
/** contract an object(s) in 2D/3D space
 * @param {float} radius - the radius to contract by
 * @param {Object} object a CSG/CAG objects to contract
 * @returns {CSG/CAG} new CSG/CAG object , contracted
 *
 * @example
 * let contractedShape = contract([0.2,15,1], sphere())
 */


function contract(radius, n, object) {
  return object.contract(radius, n);
}
/** create a minkowski sum of the given shapes
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to create a hull around
 * @returns {CSG} new CSG object , mirrored
 *
 * @example
 * let hulled = hull(rect(), circle())
 */


function minkowski() {
  console.log('minkowski() not yet implemented');
}
/** create a convex hull of the given shapes
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to create a hull around
 * @returns {CSG} new CSG object , a hull around the given shapes
 *
 * @example
 * let hulled = hull(rect(), circle())
 */


function hull() {
  var pts = [];
  var a = arguments;
  if (a[0].length) a = a[0];
  var done = [];

  for (var i = 0; i < a.length; i++) {
    // extract all points of the CAG in the argument list
    var cag = a[i];

    if (!isCAG(cag)) {
      throw new Error('ERROR: hull() accepts only 2D forms / CAG');
    }

    for (var j = 0; j < cag.sides.length; j++) {
      var x = cag.sides[j].vertex0.pos.x;
      var y = cag.sides[j].vertex0.pos.y; // avoid some coord to appear multiple times

      if (done['' + x + ',' + y]) {
        continue;
      }

      pts.push({
        x: x,
        y: y
      });
      done['' + x + ',' + y]++; // echo(x,y);
    }
  } // echo(pts.length+" points in",pts);
  // from http://www.psychedelicdevelopment.com/grahamscan/
  //    see also at https://github.com/bkiers/GrahamScan/blob/master/src/main/cg/GrahamScan.java


  var ConvexHullPoint = function ConvexHullPoint(i, a, d) {
    this.index = i;
    this.angle = a;
    this.distance = d;

    this.compare = function (p) {
      if (this.angle < p.angle) {
        return -1;
      } else if (this.angle > p.angle) {
        return 1;
      } else {
        if (this.distance < p.distance) {
          return -1;
        } else if (this.distance > p.distance) {
          return 1;
        }
      }

      return 0;
    };
  };

  var ConvexHull = function ConvexHull() {
    this.points = null;
    this.indices = null;

    this.getIndices = function () {
      return this.indices;
    };

    this.clear = function () {
      this.indices = null;
      this.points = null;
    };

    this.ccw = function (p1, p2, p3) {
      var ccw = (this.points[p2].x - this.points[p1].x) * (this.points[p3].y - this.points[p1].y) - (this.points[p2].y - this.points[p1].y) * (this.points[p3].x - this.points[p1].x); // we need this, otherwise sorting never ends, see https://github.com/Spiritdude/OpenJSCAD.org/issues/18

      if (ccw < 1e-5) {
        return 0;
      }

      return ccw;
    };

    this.angle = function (o, a) {
      // return Math.atan((this.points[a].y-this.points[o].y) / (this.points[a].x - this.points[o].x));
      return Math.atan2(this.points[a].y - this.points[o].y, this.points[a].x - this.points[o].x);
    };

    this.distance = function (a, b) {
      return (this.points[b].x - this.points[a].x) * (this.points[b].x - this.points[a].x) + (this.points[b].y - this.points[a].y) * (this.points[b].y - this.points[a].y);
    };

    this.compute = function (_points) {
      this.indices = null;

      if (_points.length < 3) {
        return;
      }

      this.points = _points; // Find the lowest point

      var min = 0;

      for (var _i = 1; _i < this.points.length; _i++) {
        if (this.points[_i].y === this.points[min].y) {
          if (this.points[_i].x < this.points[min].x) {
            min = _i;
          }
        } else if (this.points[_i].y < this.points[min].y) {
          min = _i;
        }
      } // Calculate angle and distance from base


      var al = [];
      var ang = 0.0;
      var dist = 0.0;

      for (var _i2 = 0; _i2 < this.points.length; _i2++) {
        if (_i2 === min) {
          continue;
        }

        ang = this.angle(min, _i2);

        if (ang < 0) {
          ang += Math.PI;
        }

        dist = this.distance(min, _i2);
        al.push(new ConvexHullPoint(_i2, ang, dist));
      }

      al.sort(function (a, b) {
        return a.compare(b);
      }); // Create stack

      var stack = new Array(this.points.length + 1);
      var j = 2;

      for (var _i3 = 0; _i3 < this.points.length; _i3++) {
        if (_i3 === min) {
          continue;
        }

        stack[j] = al[j - 2].index;
        j++;
      }

      stack[0] = stack[this.points.length];
      stack[1] = min;
      var tmp;
      var M = 2;

      for (var _i4 = 3; _i4 <= this.points.length; _i4++) {
        while (this.ccw(stack[M - 1], stack[M], stack[_i4]) <= 0) {
          M--;
        }

        M++;
        tmp = stack[_i4];
        stack[_i4] = stack[M];
        stack[M] = tmp;
      }

      this.indices = new Array(M);

      for (var _i5 = 0; _i5 < M; _i5++) {
        this.indices[_i5] = stack[_i5 + 1];
      }
    };
  };

  var hull = new ConvexHull();
  hull.compute(pts);
  var indices = hull.getIndices();

  if (indices && indices.length > 0) {
    var ch = [];

    for (var _i6 = 0; _i6 < indices.length; _i6++) {
      ch.push(pts[indices[_i6]]);
    }

    return fromPoints(ch);
  }
}
/** create a chain hull of the given shapes
 * Originally "Whosa whatsis" suggested "Chain Hull" ,
 * as described at https://plus.google.com/u/0/105535247347788377245/posts/aZGXKFX1ACN
 * essentially hull A+B, B+C, C+D and then union those
 * @param {Object(s)|Array} objects either a single or multiple CSG/CAG objects to create a chain hull around
 * @returns {CSG} new CSG object ,which a chain hull of the inputs
 *
 * @example
 * let hulled = chain_hull(rect(), circle())
 */


function chain_hull(params, objects) {
  /*
  const defaults = {
    closed: false
  }
  const closed = Object.assign({}, defaults, params) */
  var a = arguments;
  var closed = false;
  var j = 0;

  if (a[j].closed !== undefined) {
    closed = a[j++].closed;
  }

  if (a[j].length) {
    a = a[j];
  }

  var hulls = [];
  var hullsAmount = a.length - (closed ? 0 : 1);

  for (var i = 0; i < hullsAmount; i++) {
    hulls.push(hull(a[i], a[(i + 1) % a.length]));
  }

  return union(hulls);
}

module.exports = {
  translate: translate,
  center: center,
  scale: scale,
  rotate: rotate,
  transform: transform,
  mirror: mirror,
  expand: expand,
  contract: contract,
  minkowski: minkowski,
  hull: hull,
  chain_hull: chain_hull
};